import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { defaultLocale } from './redux/i18n/i18n.slice';

export const i18nPromise = i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLocale,
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly', // ignore country code in languages
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ['navigator', 'localStorage'],
    },
    backend: {
      requestOptions: {
        cache: 'no-cache',
      },
    },
  });

export default i18n;
